/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomInput from "components/fragments/CustomInput";
import SelectStaffCard from "components/layouts/SelectStaffCard"; // เปลี่ยนเป็น layouts ตามไฟล์ที่ 2
import ModalConfirm from "components/layouts/ModalConfirm"; // เปลี่ยนเป็น layouts ตามไฟล์ที่ 2
import { posHandler } from "../../redux/handlers";

export default function PayStaff({ user, ui, ...props }) {
  const {
    setStaffSelect,
    selectedUser,
    setSelectedUser,
    userInfo,
    setUserInfo,
  } = user;

  const {
    modals: { setOpen: setModalSuccessOpen, setText: setModalSuccessText },
  } = ui;

  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [modalConfirmOpen, setModalConfirmOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [employeesList, setEmployeesList] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [isError, setIsError] = useState();
  const branchId = localStorage.getItem("branchId");

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await dispatch(
          posHandler.getBranchEmployees(businessSlug, branchId)
        );
        if (response) {
          const formattedEmployees = response.map((item) => ({
            id: item.userBusinessGroup.id,
            fullName: `${item.userBusinessGroup.first_name || ""} ${
              item.userBusinessGroup.last_name || ""
            }`.trim(),
            code: item.userBusinessGroup.code,
            phoneNumber: item.userBusinessGroup.phone_number,
            pin: item.userBusinessGroup.emp_pin,
          }));
          setEmployeesList(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, [dispatch, businessSlug]);

  useEffect(() => {
    if (!keyword) {
      setFilteredUserList([]);
      return;
    }

    const filtered = employeesList.filter(
      (user) =>
        user.fullName.toLowerCase().includes(keyword.toLowerCase()) ||
        user.code.toLowerCase().includes(keyword.toLowerCase()) ||
        (user.phoneNumber && user.phoneNumber.includes(keyword))
    );

    setFilteredUserList(filtered);
  }, [keyword, employeesList]);

  const handleConfirm = useCallback(() => {
    setUserInfo(selectedUser);
    setModalSuccessText("เพิ่มพนักงานสำเร็จ");
    setModalSuccessOpen(true);
    setStaffSelect(false);
  }, [
    selectedUser,
    setUserInfo,
    setModalSuccessText,
    setModalSuccessOpen,
    setStaffSelect,
  ]);

  const handleDeleteConfirm = useCallback(() => {
    setUserInfo(null);
    setStaffSelect(false);
    setModalConfirmOpen(false);
    setModalSuccessText("ลบพนักงานสำเร็จ");
    setModalSuccessOpen(true);
  }, [setUserInfo, setStaffSelect, setModalSuccessText, setModalSuccessOpen]);

  useEffect(() => {
    if (userInfo && !keyword) {
      setKeyword(userInfo.fullName || "");
    }
  }, []);

  const pageTitle = userInfo ? "แก้ไขพนักงาน" : "เพิ่มพนักงานขาย";

  return (
    <div className="d-flex flex-column h-100">
      <div className="fs-22 fw-500 mb-2">{pageTitle}</div>

      <CustomInput
        className="mt-[min(0.98vw,10px)] w-full"
        inputprops={{
          className:
            "rounded-[min(0.78vw,8px)] border-[min(0.10vw,1px)] border-[#b6bbc6] py-[min(1.03vw,10.5px)] px-[min(1.46vw,15px)] font-[400] text-16",
          placeholder: "พิมพ์ชื่อ/รหัสพนักงาน",
          onChange: (e) => setKeyword(e.currentTarget.value),
          value: keyword,
          error: isError,
        }}
      />

      {filteredUserList && filteredUserList.length > 0 && (
        <div
          className="mt-[min(1.46vw,15px)] mb-[min(1.46vw,15px)] flex flex-col gap-[min(1.27vw,13px)]"
          style={{ maxHeight: "450px", overflow: "auto" }}
        >
          {filteredUserList.map((value, index) => {
            return (
              <SelectStaffCard
                key={index}
                onClick={() => setSelectedUser(value)}
                userInfo={{
                  id: value.id,
                  fullName: value.fullName,
                  code: value.code,
                }}
                selected={selectedUser && value.id === selectedUser.id}
              />
            );
          })}
        </div>
      )}

      <div className="d-flex align-items-center pt-2 mt-auto">
        {userInfo && (
          <button
            className="me-auto btn btn-st-q1 px-3 bg-[#F95057] text-[#FFF]"
            style={{ width: "70px" }}
            onClick={() => setModalConfirmOpen(true)}
          >
            ลบ
          </button>
        )}

        <button
          className={`${
            userInfo ? "ms-auto me-3" : "me-auto"
          } btn btn-st-q1 px-4 bg-[#E6E6E6] text-[#6D788D]`}
          onClick={() => setStaffSelect(false)}
        >
          ยกเลิก
        </button>

        <button
          className="btn dp btn-st-q1"
          disabled={!selectedUser}
          onClick={handleConfirm}
        >
          ยืนยัน
        </button>
      </div>

      <ModalConfirm
        textobj={{ t1: "คุณต้องการยืนยันการลบพนักงาน" }}
        modalOpenObj={{
          modalOpen: modalConfirmOpen,
          setModalOpen: setModalConfirmOpen,
        }}
        handleConfirm={handleDeleteConfirm}
      />
    </div>
  );
}
